import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useIsBackFromSubscriptionCheckout } from "../../../../legacy/components/PaymentBackdrop/hooks/use-is-back-from-subscription-checkout";
import { isBackFromCheckoutAtom } from "../../store/checkout-return.store";

function CheckoutReturnListener(): null {
  const isBackFromCheckout = useIsBackFromSubscriptionCheckout();
  const setIsBackFromCheckout = useSetAtom(isBackFromCheckoutAtom);

  useEffect(
    function trackCheckoutReturn() {
      if (isBackFromCheckout) {
        setIsBackFromCheckout(true);
      }
    },
    [isBackFromCheckout, setIsBackFromCheckout]
  );

  useEffect(
    function resetOnRouteUnmount() {
      return function cleanup() {
        setIsBackFromCheckout(false);
      };
    },
    [setIsBackFromCheckout]
  );

  return null;
}

export default CheckoutReturnListener;
